import { $ } from "kw/api";
import { useAPI } from "kw/api/useAPI";
import { useState } from "react";

export const useCustomers = () => {
  const [customers, setCustomers] = useState<TCustomers>();
  const [customer, setCustomer] = useState<TCustomerDetails>();
  const { query, mutation, loading } = useAPI();
  const fetchCustomers = (search = "", page: number) => {
    query(
      customersQuery,
      (response: { admin: { customers: TCustomers } }) => {
        setCustomers(response.admin.customers);
      },
      {
        search,
        page,
      }
    );
  };

  const searchCustomers = (search = "", page = 1) => {
    query(
      customersQuery,
      (response: { admin: { customers: TCustomers } }) => {
        setCustomers(response.admin.customers);
      },
      {
        search: search,
        page: page,
      }
    );
  };

  const fetchCustomer = (id: string) => {
    query(
      customerQuery,
      (response: { admin: { customer: TCustomerDetails } }) => {
        setCustomer(response.admin.customer);
      },
      {
        id,
      }
    );
  };

  // TODO email is a uuid, figure out why so we never show a uuid in the email field here: http://kanopiplatform.test/admin/c
  const createLazyUser = async (
    email = "",
    firstName = "",
    lastName = ""
  ): Promise<TUser> => {
    return new Promise((resolve, reject) => {
      mutation(
        createLazyUserQuery,
        (response: { admin: { createLazyUser: TUser } }) => {
          resolve(response.admin.createLazyUser);
        },
        { email, firstName, lastName },
        reject
      );
    });
  };

  return {
    customers,
    customer,
    loading,
    fetchCustomers,
    fetchCustomer,
    searchCustomers,
    createLazyUser,
  };
};

const customersQuery = {
  admin: {
    customers: [
      {
        search: $("search", "String!"),
        page: $("page", "Int!"),
      },
      {
        totalItemCount: true,
        page: true,
        pageCount: true,
        pageSize: true,
        hasNext: true,
        hasPrev: true,
        items: {
          id: true,
          fullName: true,
          email: true,
          contactEmail: true,
          dateJoined: true,
          isActive: true,
          allowClaim: true,
        },
      },
    ],
  },
};

const customerQuery = {
  admin: {
    customer: [
      {
        id: $("id", "ID!"),
      },
      {
        details: {
          id: true,
          email: true,
          contactEmail: true,
          firstName: true,
          lastName: true,
          dateJoined: true,
          contactNumber: true,
          isLazy: true,
          latestReferrer: {
            name: true,
          },
          isActive: true,
          allowClaim: true,
        },
        quotes: {
          id: true,
          startDate: true,
          finishDate: true,
          amountDue: true,
          stateDisplay: true,
          state: true,
        },
        policies: {
          id: true,
          policyNumber: true,
          status: true,
          statusDisplay: true,
          startDate: true,
          finishDate: true,
          quote: {
            postTaxPremium: true,
          },
        },
        claims: {
          id: true,
          claimNumber: true,
          status: true,
          statusType: true,
          statusTypeDisplay: true,
          policyNumber: true,
          created: true,
        },
        payments: {
          id: true,
          amount: true,
          transactionType: true,
          transactionTypeDisplay: true,
          actionType: true,
          actionTypeDisplay: true,
          policyNumber: true,
          paymentProfile: {
            customerReference: true,
          },
          status: true,
          statusDisplay: true,
        },
      },
    ],
  },
};

const createLazyUserQuery = {
  admin: {
    createLazyUser: [
      {
        input: {
          email: $("email", "String!"),
          firstName: $("firstName", "String!"),
          lastName: $("lastName", "String!"),
        },
      },
      {
        uuid: true,
        id: true,
        firstName: true,
        lastName: true,
        email: true,
      },
    ],
  },
};
